import { useTheme } from "@emotion/react";

import { SingleTheme } from "@/types/tokens/themes";

export function useTypedTheme() {
    return useTheme() as SingleTheme;
}
